import AddIcon from '@mui/icons-material/Add';
import { Avatar, Button, Divider, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, ListSubheader, Slider, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from "react";
import { Card, Col, Container, Form, FormControl, FormGroup, InputGroup, Row, Spinner, Tab, Table, Tabs } from "react-bootstrap";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaEdit, FaSave, FaSearch, FaTrash } from "react-icons/fa";
import { Phones } from "../../../components/sub-render.component";
import TableContainer from "../../../components/table-container.component";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import authService from "../../../services/auth.service";
import cduService from "../../../services/cdu.service";
import lclService from "../../../services/lcl.service";
import bnfService from "../../../services/bnf.service";
import { dateToString, notNullToDate, toBoolean, toString, toUpperCase } from "../../../utilities/auxiliary-functions";
import { PermissionEnum } from "../../../utilities/constants";
import { cnpjMask, numberMask, phoneMask, removeFormatDate, removeMask, zipcodeMask } from "../../../utilities/masks";
import { AlertMessageEnum } from "../../../utilities/types";
import { isCnpj, isEmpty } from "../../../utilities/validators";
import EmployeeCadastreModal from "../../modals/employee.cadastre.modal";
import SocietyCadastreModal from "../../modals/society.cadastre.modal";
import AddressRecord from "../../records/address.record";
import CorporateDataRecord from "../../records/corporate-data.record";

import { Editor } from '../../../components/editor.component';
import moment from 'moment';
import { openDocument } from '../../../utilities/view-document';
import { TFilter } from '../../../types/FilterType';
import { useTranslateContext } from '../../../contexts/translate.context';
import { usePartnerContext } from '../../../contexts/partner.context';

export interface IBenefitFormProps {
    title: string,
    benefitId: string,
    setRecord: any,
    viewOnly?: boolean
}

export const BenefitForm: React.FC<IBenefitFormProps> = (props: IBenefitFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(true);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);

    /* TRATAMENTO PARTICULAR DO OBJETO QUE ESTA SENDO MANTIDO */
    // Benefit
    const [ benefitId, setbenefitId ] = useState(0);
    const [ codiname, setCodiname ] = useState('');
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    // Company
    const [ companyId, setCompanyId ] = useState(0);
    const [ situationCompany, setSituationCompany ] = useState(0);
    const [ image, setImage ] = useState('');
    const [ socialReason, setSocialReason ] = useState('');
    const [ fantasy, setFantasy ] = useState('');
    const [ sector, setSector ] = useState('');
    const [ registrationPj, setRegistrationPj ] = useState('');
    const [ registrationState, setRegistrationState ] = useState('');
    const [ foundation, setFoundation ] = useState('');
    const [ site, setSite ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ telephone, setTelephone ] = useState('');
    const [ whatsapp, setWhatsapp ] = useState('');
    const [ url, setUrl ] = useState('');
    const [ latitude, setLatitude ] = useState('');
    const [ longitude, setLongitude ] = useState('');

    // Address
    const [ addressId, setAddressId ] = useState(0);
    const [ zipcode, setZipcode ] = useState('');
    const [ state, setState ] = useState('');
    const [ city, setCity ] = useState('');
    const [ district, setDistrict ] = useState('');
    const [ place, setPlace ] = useState('');
    const [ habitation, setHabitation ] = useState('');
    const [ complement, setComplement ] = useState('');
    
    type ArtifactType = { id : number, norm : string, source : string, identy : string, document : string, filename : string };
    const DEFAULT_ARTIFACT: ArtifactType = { id : 0, norm : '', source : '', identy : '', document : '', filename : '' };
    
    const [ proofOfResidenceDocument, setProofOfResidenceDocument ] = useState(DEFAULT_ARTIFACT);
    const [ isChangedProofOfResidenceDocument, setChangedProofOfResidenceDocument ] = useState(false);
    
    function fillRecord(benefit: any) {

        if (!isEmpty(benefit)) {
            setbenefitId(benefit.id);
            setCodiname(benefit.codiname);
            setCreated(notNullToDate(benefit.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(benefit.updated, 'dd/mm/yyyy HH:MM:ss'));  

            fillRecordCompany(benefit.company);
        }
    } // fillRecord

    function fillRecordCompany(company: any) {

        if (!isEmpty(company)) {
            setCompanyId(company.id);
            setImage(company.image);
            setSituationCompany(company.situation);
            setSocialReason(company.socialReason);
            setFantasy(company.fantasy);
            setSector(company.sector);
            setRegistrationPj(cnpjMask(company.registrationPj));
            setRegistrationState(numberMask(company.registrationState));
            setFoundation(notNullToDate(company.foundation, 'dd/mm/yyyy'));
            setSite(company.site);
            setEmail(company.email);
            setTelephone(phoneMask(company.telephone));
            setWhatsapp(phoneMask(company.whatsapp));
            setUrl(company.url);
            setLatitude(company.latitude);
            setLongitude(company.longitude);

            // Address
            setAddressId(company.addressId);
            setZipcode(zipcodeMask(company.address.zipcode));
            setState(company.address.state);
            setCity(company.address.city);
            setDistrict(company.address.district);
            setPlace(company.address.place);
            setHabitation(company.habitation);
            setComplement(company.complement);
        }
    }

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (isEmpty(socialReason))
            emptyRequired = true;
        if (isEmpty(fantasy))
            emptyRequired = true;
        if (isEmpty(registrationPj))
            emptyRequired = true;
        if ((!isEmpty(registrationPj)) && (!isCnpj(registrationPj))) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.registration_pj);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    async function onClick_Cancelbenefit(event : any) {
        event.preventDefault();
        props.setRecord(event, 0)
    } // onClick_Cancel

    function clearbenefit() {

        setbenefitId(0);
        setCodiname('');
        setCreated('');
        setUpdated('');
    }

    function fillBenefit() {

        const databenefit = {
            id : benefitId,
            codiname, 
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated),
            partnerId : partner.id,
            partner : partner,
            companyId,
            company : {
                id : companyId,
                situation : situationCompany,
                image : image,
                socialReason, 
                fantasy, 
                sector, 
                registrationPj : removeMask(registrationPj), 
                registrationState, 
                foundation : removeFormatDate(foundation),
                site, 
                email, 
                telephone : removeMask(telephone), 
                whatsapp : removeMask(whatsapp), 
                url, 
                latitude, 
                longitude, 
                created : removeFormatDate(created), 
                updated : removeFormatDate(updated), 
                addressId,
                address : {
                    id : addressId,
                    zipcode : removeMask(zipcode), 
                    state, 
                    city, 
                    district, 
                    place 
                },
                habitation, 
                complement
            }
        };

        return databenefit;
    }

    async function onClick_Savebenefit(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    const benefit = fillBenefit();
                    if (benefit.id > 0)
                        await bnfService.saveBenefit(benefit.id, benefit);
                    else
                        await bnfService.createBenefit(benefit);
                
                    if (isChangedProofOfResidenceDocument && proofOfResidenceDocument) {
                        proofOfResidenceDocument.source = 'COMPANY';
                        proofOfResidenceDocument.identy = String(partner.company.id);
    
                        if ((proofOfResidenceDocument.id > 0) && !isEmpty(proofOfResidenceDocument.document)) {
                            await cduService.saveArtifact(proofOfResidenceDocument.id, proofOfResidenceDocument);
                        } else if ((proofOfResidenceDocument.id > 0) && isEmpty(proofOfResidenceDocument.document)) {
                            await cduService.artifactDeleteById(proofOfResidenceDocument.id);
                        } else if ((proofOfResidenceDocument.id === 0) && !isEmpty(proofOfResidenceDocument.document)) {
                            await cduService.createArtifact(proofOfResidenceDocument);
                        }
                    }
                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    props.setRecord(event, 0)
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_Savebenefit
    
    async function onClick_SearchCompany(event: any) {
        event.preventDefault();

        if (!isEmpty(registrationPj)) {
            const registration = removeMask(registrationPj);
            if (isCnpj(registration)) {
                const company = await cduService.companyByRegistration(registration);
                fillRecordCompany(company);
                if (!isEmpty(company)) {
                    const filter = {
                        where: { companyId: company.id }
                    } as TFilter;
                    let partnerFilter = await lclService.partnerFilter(filter); // {count: 0, rows: []} as any; 
                    if (partnerFilter.rows.length > 0) {
                        await alertContext.show(AlertMessageEnum.SUCCESS, props.title, 'CNPJ já cadastrado.');
                        props.setRecord(event, 0);
                    }
                } else 
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, 'CNPJ não localizado. Efetue o cadastro completo.');

                } else {
                await alertContext.show(AlertMessageEnum.FAIL, props.title, 'CNPJ Inválido !');
            }
        } else {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, 'Insira um CNPJ válido !');
        }
    }

    async function searchParam() {
        try {
            clearbenefit();
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.benefitId ||''))) {

                const benefit = await bnfService.benefitById(Number(props.benefitId));
                if (benefit.companyId > 0) {
                    const company = await cduService.companyById(Number(benefit.companyId));
                    benefit.company = company;
                }
                fillRecord(benefit);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            searchParam();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function changeImage(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                setImage(e.target.result);
            };
            reader.readAsDataURL(event.target.files[0]);
        } else {
            setImage('');
        }
    }

    function changeProofOfResidenceDocument(event: any) {
        setChangedProofOfResidenceDocument(true);
        if (event.target.files && event.target.files.length > 0) {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                let artfact: ArtifactType = {
                    id : proofOfResidenceDocument.id,
                    norm : 'FILE_RESIDENCE',
                    source : 'COMPANY',
                    identy : String(companyId),
                    document : e.target.result,
                    filename : event.target.files[0].name
                }
                setProofOfResidenceDocument(artfact);
            };
            reader.readAsDataURL(event.target.files[0]);
        } else {
            let artifact: ArtifactType = { id : proofOfResidenceDocument.id, norm : 'FILE_RESIDENCE', source : 'COMPANY', identy : String(companyId), document : '', filename : '' };
            setProofOfResidenceDocument(artifact);
        }
    }

    function clickViewDocument(event: any, title: string, url: any) {
        event.preventDefault();
        openDocument(title, url);
    } 
    
    function viewCadastreForm() {

        return (
            <Container fluid className="page-body benefit">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord.created || originRecord.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre-benefit" validated={invalidatedForm}>
                                    <Row>
                                        {(benefitId === 0) && (
                                            <Col sm="5">
                                                <FormGroup>
                                                    <Form.Label htmlFor="form-registration_pj">{display.label.registration_pj}</Form.Label>
                                                    <InputGroup className="mb-2">
                                                        <FormControl type="text" id="form-registration_pj" name="registration_pj" placeholder={'Digite o CNPJ'} required 
                                                            value={toString(registrationPj)}
                                                            onChange={e => setRegistrationPj(cnpjMask(e.target.value))}
                                                        />
                                                        <InputGroup.Text>
                                                            <a href="/#" onClick={onClick_SearchCompany}>
                                                                <FaSearch />
                                                            </a>
                                                        </InputGroup.Text>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        )}
                                        <Col>
                                            <FormGroup>
                                                <Form.Label htmlFor="form-codiname">{display.label.codiname}</Form.Label>
                                                <FormControl id="form-codiname" name="codiname" placeholder={display.example.codiname}
                                                    value={codiname}
                                                    onChange={e => setCodiname(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row sm="12" className="ms-1 me-1"><Col className="ps-1 pe-1" ><hr /></Col></Row>
                                    <Row>
                                        <Col>
                                            <fieldset>
                                                <legend>{display.legend.general_data}</legend>
                                                <CorporateDataRecord 
                                                    title={props.title}
                                                    isEdit={isEditForm}
                                                    identifier={benefitId === 0}

                                                    socialReason={socialReason}
                                                    fantasy={fantasy}
                                                    sector={sector}
                                                    registrationPj={registrationPj}
                                                    registrationState={registrationState}
                                                    foundation={foundation}
                                                    site={site}
                                                    email={email}
                                                    telephone={telephone}
                                                    whatsapp={whatsapp}
                                                    situation={situationCompany}
                                                    image={image}
                                                    setSocialReason={(value: any) => { setSocialReason(value); }}  
                                                    setFantasy={(value: any) => { setFantasy(value); }}  
                                                    setSector={(value: any) => { setSector(value); }}  
                                                    setRegistrationPj={(value: any) => { setRegistrationPj(value); }}  
                                                    setRegistrationState={(value: any) => { setRegistrationState(value); }} 
                                                    setFoundation={(value: any) => { setFoundation(value); }} 
                                                    setSite={(value: any) => { setSite(value); }} 
                                                    setEmail={(value: any) => { setEmail(value); }} 
                                                    setTelephone={(value: any) => { setTelephone(value); }} 
                                                    setWhatsapp={(value: any) => { setWhatsapp(value); }} 
                                                    setSituation={(value: any) => { setSituationCompany(value); }} 
                                                    changeImage={(event: any) => { changeImage(event); }} 
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>{display.legend.address}</legend>
                                                <AddressRecord 
                                                    title={props.title}
                                                    isEdit={isEditForm}
                                                    identifier={benefitId === 0}

                                                    zipcode={zipcode}
                                                    state={state}
                                                    city={city}
                                                    district={district}
                                                    place={place}
                                                    habitation={habitation}
                                                    complement={complement}
                                                    setZipcode={(value: any) => { setZipcode(value); }} 
                                                    setState={(value: any) => { setState(value); }} 
                                                    setCity={(value: any) => { setCity(value); }} 
                                                    setDistrict={(value: any) => { setDistrict(value); }} 
                                                    setPlace={(value: any) => { setPlace(value); }} 
                                                    setHabitation={(value: any) => { setHabitation(value); }} 
                                                    setComplement={(value: any) => { setComplement(value); }}

                                                    attachment={true}
                                                    proofOfResidenceDocument={proofOfResidenceDocument}
                                                    changeProofOfResidenceDocument={changeProofOfResidenceDocument}
                                                    clickViewDocument={clickViewDocument}
                                                />
                                            </fieldset>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <fieldset>
                                                <legend>{display.legend.location_in_maps}</legend>
                                                <Row>
                                                    <Col sm="4">
                                                        <FormGroup>
                                                            <Form.Label htmlFor="form-url">{display.label.url}</Form.Label>
                                                            <FormControl id="form-url" name="url" placeholder={display.example.url}
                                                                value={toString(url)}
                                                                onChange={(e => setUrl(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="4">
                                                        <FormGroup>
                                                            <Form.Label htmlFor="form-latitude">{display.label.latitude}</Form.Label>
                                                            <FormControl id="form-latitude" name="latitude" placeholder={display.example.latitude}
                                                                value={toString(latitude)}
                                                                onChange={(e => setLatitude(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="4">
                                                        <FormGroup>
                                                            <Form.Label htmlFor="form-longitude">{display.label.longitude}</Form.Label>
                                                            <FormControl id="form-longitude" name="longitude" placeholder={display.example.longitude}
                                                                value={toString(longitude)}
                                                                onChange={(e => setLongitude(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </fieldset>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_Cancelbenefit(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_Savebenefit(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <>
            { viewCadastreForm() }
        </>
    );

}

export default BenefitForm;
